module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_RaggedRight",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.17em"
    }
  }, [_vm._v("Da qualche parte, l’orologio a pendolo iniziò a battere le ore. Ancor prima del terzo rintocco, Avery sollevò di scatto la testa, percependo di nuovo quel maledetto odore: la stessa fragranza misteriosa e squisita che aveva sentito la notte prima. Essendo un po’ più lucido, riuscì finalmente a capire a cosa assomigliasse: al cioccolato. Gli ricordava i deliziosi cioccolatini che sua madre gli portava dai suoi viaggi oltreoceano.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Quell’aroma caldo e appetitoso gli fece venire l’acquolina in bocca. Amava i cioccolatini, la loro ricca cremosità e la sensazione dolce e setosa quando gli si scioglievano sulla lingua. Ma di solito non gli procuravano un’erezione, e il suo uccello traditore si era rizzato sull’attenti.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Il cuore gli batté un colpo sordo nel petto, poi prese a palpitare sempre più in fretta a mano a mano che il profumo si faceva più intenso. Cercando di ignorare i suoi battiti frenetici, si concentrò sui passi in avvicinamento.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Davvero suo padre non se n’era accorto? O lo sentiva solo lui? Cazzo, è di questo che parlano le coppie destinate a unirsi quando si riferiscono a un odore irresistibile? Tutte le domande della sera prima, su cosa significasse quella fragranza per lui, ora avevano una risposta. Non sapeva se ululare per la felicità o scappare dalla stanza.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("Quel maledetto drago era il suo consorte predestinato, non c’era alcun dubbio… sempre che quanto avesse sentito dire fino a quel momento fosse vero. Si voltò lentamente sulla poltrona per fissare la porta. Il battito del suo cuore aumentò ancora al bussare autoritario del compagno.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("L’Alfa alzò lo sguardo. Annusò l’aria e cancellò ogni traccia di emozione dal viso. “Avanti.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_RaggedRight"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "1.00em"
    }
  }, [_vm._v("La maniglia iniziò a muoversi un doloroso millimetro alla volta e a Avery si impigliò il respiro in gola. Oh cielo, apri quella maledetta porta! Il battito del suo cuore si era fatto implacabile. Senza fiato, strinse i braccioli della poltrona mentre guardava la maniglia abbassarsi.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e555470","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0